import React from 'react'

import { FormattedMessage } from '@divvy-web/i18n'
import { FormDropdown, FormDropdownProps } from '@divvy-web/skylab.form'
import { Control, FieldValues } from '@divvy-web/skylab.react-hook-form'

export interface AccountingSoftwareDropdownProps<T extends FieldValues = FieldValues> extends Omit<
  FormDropdownProps,
  'options' | 'name'
> {
  control: Control<T>
  name?: string
}

const accountingSoftwareOptions = [
  { value: 'qboe2', label: 'QuickBooks Online' },
  { value: 'qbd', label: 'QuickBooks Pro/Premier' },
  { value: 'qbe', label: 'QuickBooks Enterprise' },
  { value: 'xero2', label: 'Xero' },
  { value: 'netsuite2', label: 'NetSuite' },
  { value: 'intacct2', label: 'Intacct' },
  { value: 'acumatica', label: 'Acumatica' },
  { value: 'blackbaud', label: 'Blackbaud' },
  { value: 'sap', label: 'SAP' },
  { value: 'sageplus', label: 'Sage (200/300/ERP)' },
  { value: 'freshbooks', label: 'Freshbooks' },
  { value: 'qbmac', label: 'QuickBooks for Mac' },
  { value: 'quicken', label: 'Quicken' },
  { value: 'sage100', label: 'Sage 100' },
  { value: 'sage50', label: 'Sage 50' },
  { value: 'reuters', label: 'Thomson Reuters' },
  { value: 'yardi', label: 'Yardi' },
  { value: 'other', label: 'Other' },
  { value: 'none', label: 'None' },
  { value: 'unknown', label: "I don't know" },
  { value: 'msdynamicsgp', label: 'MS Dynamics GP' },
  { value: 'msdynamicsbizcentral', label: 'MS Dynamics 365 Business Central' },
  { value: 'msdynamics', label: 'MS Dynamics (AX, NAV, SL, 365 F&O)' },
]

export const getAccountingSoftwareItem = (value: string) => {
  const selectedItem = accountingSoftwareOptions.find((item) => item.value === value)
  return {
    accountingSoftwareKey: selectedItem?.value ?? null,
    accountingSoftwareValue: selectedItem?.label ?? null,
  }
}

const AccountingSoftwareDropdown = <T extends FieldValues>({
  control,
  ...props
}: AccountingSoftwareDropdownProps<T>) => {
  return (
    <FormDropdown
      isSearchable
      className='AccountingSoftwareDropdown'
      control={control}
      label={
        <FormattedMessage
          defaultMessage='Accounting software'
          id='sputnik.AccountingSoftwareDropdown__WAi7JV'
        />
      }
      name='accountingSoftware'
      options={accountingSoftwareOptions}
      placeholder={
        <FormattedMessage
          defaultMessage='Select'
          id='sputnik.AccountingSoftwareDropdown__kQAf2d'
        />
      }
      {...props}
    />
  )
}

export default AccountingSoftwareDropdown
